<template>
  <v-container fluid class="my-5">
    <MesaDirectivaReuniones />
  </v-container>
</template>

<script>
import MesaDirectivaReuniones from '@/components/mesaDirectiva/MesaDirectivaReuniones.vue'

export default {
  name: 'mesa_directiva_reuniones',
  components: {
    MesaDirectivaReuniones
  }
}
</script>
